import { render, staticRenderFns } from "./handleRefund.vue?vue&type=template&id=c622e85a&scoped=true&"
import script from "./handleRefund.vue?vue&type=script&lang=js&"
export * from "./handleRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c622e85a",
  null
  
)

export default component.exports